import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { CropperPosition, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'piqet-angular-change-profile-img',
  templateUrl: './change-profile-img.component.html',
  styleUrls: ['./change-profile-img.component.css'],
})
export class ChangeProfileImgComponent {
  @Input() userProfileImage!: any;
  @Output() updateUserProfileImage = new EventEmitter<any>();

  imgsrc: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};
  changeImageForm!: FormGroup;
  fileName: any;
  formData: any;
  ContentSaveObj: any;
  stream: any;
  fileBase64: any;
  lastModificationdate: any;
  cropper: any;

  constructor(
    public _d: DomSanitizer,
    private formBuilder: FormBuilder,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.changeImageForm = this.formBuilder.group({
      image: ['', Validators.required],
    });
    this.cropper = {
      x1: 130,
      y1: 156,
      x2: 455,
      y2: 486,
    };
    // eslint-disable-next-line no-prototype-builtins
    this.imgsrc =
      this.userProfileImage?.hasOwnProperty('image') && this.userProfileImage?.image
        ? 'data:image/jpg;base64,' + this.userProfileImage.image
        : '/assets/images/defaultProfile.jpg';
  }

  fileChangeEvent(e: any) {
    this.getFileStream(e.target.files[0]);
  }

  getFileStream(file: any): void {
    if (!file) {
      return;
    }
    this.fileName = file.name;
    this.lastModificationdate = file.lastModifiedDate.toISOString();
    const reader = new FileReader(); // HTML5 FileReader API
    reader.readAsDataURL(file);
    // When file uploads set it to file formcontrol
    reader.onload = () => {
      this.stream = reader.result;
      this.fileBase64 = this.stream.split(',')[1];
    };
    // this.ContentSaveObj.image = '';
    this.changeImageForm.patchValue({
      image: '',
    });
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64?.split(',')[1];
  }

  imageLoaded() {
    this.showCropper = true;
    setTimeout(() => {
      this.cropper = {
        x1: 130,
        y1: 156,
        x2: 455,
        y2: 486,
      };
    }, 2);
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

  zoomOut(event: any) {
    if (this.scale > 1) {
      this.scale -= 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale,
      };
    }
  }

  zoomIn(event: any) {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  updateRotation() {
    this.transform = {
      ...this.transform,
      rotate: this.rotation,
    };
  }

  submit() {
    const data = {
      id: this.userProfileImage !== undefined ? this.userProfileImage.id : 0,
      imageStr: this.fileBase64 || this.userProfileImage?.image,
      imageThumbStr: this.croppedImage,
      modifiedOn: this.lastModificationdate,
      userId: Number(this.cookieService.get('userId')),
    };
    this.updateUserProfileImage.emit(data);
  }
}
